export function unwrapResponse(response) {
  return response.data;
}

export function defaultTransformResponse(baseQueryReturnValue) {
  return unwrapResponse(baseQueryReturnValue);
}